module.exports = __webpack_public_path__ + "static/media/th-large.c8ae3fa8.svg";